import { saveResponseAsBlob } from '@/helpers/save-blob'

export default
{
	methods:
	{
		async downloadInvoice(accountNumber, filename)
		{
			try
			{
				const response = await this.$http.get
				(
					'/api/accounts/' + accountNumber + '/invoices/' + filename,
					{
						params: { _: ( new Date ).getTime() },

						responseType: 'arraybuffer',
					}
				)

				saveResponseAsBlob(response)
			}
			catch(err)
			{
				this.sendErrorNotification('Unable to download invoice')

				console.error(err)
			}
		},

		invoiceFilename(accountNumber, date)
		{
			let month = 1;

			month = ( (date.getMonth() + 1) >= 1 && (date.getMonth() + 1) <= 9 ) ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;

			return accountNumber +  "_" + month +  date.getFullYear() + ".pdf"
		}
	},
}